export default "__VITE_ASSET__CgNwNZLc__"